import type { GenEvent } from '@ads/shared';
import { parseError, sessionEvents } from './api';

/**
 * Lê um stream SSE vindo de um fetch (POST não cabe no EventSource).
 * Chama onEvent para cada evento completo, na ordem em que chegam.
 */
export async function streamGeneration(url: string, opts: {
  method?: 'GET' | 'POST'; body?: unknown; signal?: AbortSignal; onEvent: (e: GenEvent) => void;
}) {
  const method = opts.method ?? 'GET';
  const res = await fetch('/api' + url, {
    method,
    credentials: 'same-origin',
    headers: { Accept: 'text/event-stream', ...(method === 'POST' ? { 'Content-Type': 'application/json' } : {}) },
    ...(method === 'POST' ? { body: JSON.stringify(opts.body ?? {}) } : {}),
    ...(opts.signal ? { signal: opts.signal } : {}),
  });
  if (res.status === 401) sessionEvents.dispatchEvent(new Event('expired'));
  if (!res.ok || !res.body) throw await parseError(res);

  const reader = res.body.pipeThrough(new TextDecoderStream()).getReader();
  let buf = '';
  for (;;) {
    const { value, done } = await reader.read();
    if (done) break;
    buf += value;
    let i: number;
    while ((i = buf.indexOf('\n\n')) >= 0) {
      const chunk = buf.slice(0, i);
      buf = buf.slice(i + 2);
      let event = 'message';
      const data: string[] = [];
      for (const line of chunk.split('\n')) {
        if (line.startsWith('event:')) event = line.slice(6).trim();
        else if (line.startsWith('data:')) data.push(line.slice(5).trimStart());
      }
      if (event === 'ping' || !data.length) continue;
      try { opts.onEvent({ event, data: JSON.parse(data.join('\n')) } as GenEvent); }
      catch { /* evento malformado: ignora */ }
    }
  }
}
